import React from "react";

function hasHtmlTags(text: string): boolean {
  return /<[a-z][\s\S]*>/i.test(text);
}

interface HtmlContentProps {
  text: string;
  className?: string;
}

function HtmlContent({ text, className }: HtmlContentProps) {
  if (hasHtmlTags(text)) {
    return (
      <span
        className={className}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }
  return <span className={className}>{text}</span>;
}

export default HtmlContent;
